import React from "react";
import styled, {  keyframes } from "styled-components";
import * as colors from "../../assets/_base/colors";
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const Spinner = styled.div`
  border: 2px solid white;
  border-top: 3px solid transparent;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-right: 15px;
  animation: ${rotate} 1.2s linear infinite;
`;

export default props => <Spinner {...props} />


// WEBPACK FOOTER //
// ./src/_components/Spinner/index.jsx